import React, { useEffect } from 'react';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { Form, Input, Button } from 'antd';
import { Link } from 'react-router-dom';
import { useAppDispatch } from '../../store/hooks';
import { loginAction } from '../../store/slices/authSlice';
import logo from '../../img/logo.svg';

interface LoginFormValues {
  email: string;
  password: string;
}

const Login: React.FC = () => {
  const [form] = Form.useForm<LoginFormValues>();
  const dispatch = useAppDispatch();

  useEffect(() => {
    localStorage.clear();
  }, []);

  const handleSubmit = (values: LoginFormValues): void => {
    const data = {
      email: values.email,
      password: values.password,
      isAdmin: true
    };
    dispatch(loginAction(data));
  };

  return (
    <div className="gx-login-container">
      <Container>
        <Row>
          <Col>
            <div className="gx-login-content">
              <div className="gx-login-header">
                <img src={logo} alt="TopTippers" />
              </div>
              <div className="gx-text-center">
                <h2>Login</h2>
              </div>
              <Form
                form={form}
                onFinish={handleSubmit}
                layout="vertical"
                className="gx-login-form"
                initialValues={{
                  email: '',
                  password: ''
                }}
              >
                <Form.Item
                  label="Email"
                  name="email"
                  rules={[
                    {
                      type: 'email',
                      message: 'The input is not valid email',
                    },
                    { required: true, message: 'Please enter your email' }
                  ]}
                >
                  <Input placeholder="Email" />
                </Form.Item>
                <Form.Item
                  label="Password"
                  name="password"
                  rules={[{ required: true, message: 'Please enter your password' }]}
                >
                  <Input.Password
                    placeholder="Password"
                  />
                </Form.Item>
                <Form.Item className="text-right" style={{ marginBottom: '20px', marginTop: '-10px' }}>
                  <Link to="/forgot">Forgot Password?</Link>
                </Form.Item>
                <Form.Item style={{ marginBottom: 0 }}>
                  <Button type="primary" htmlType="submit">
                    Login
                  </Button>
                </Form.Item>
              </Form>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Login;
